import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useVisit, useUpdateVisit } from "../hooks";
import { VisitForm } from "../components";

type IUpdateVisit = {
  id: string;
};

export const UpdateVisit: React.FC = () => {
  const { id } = useParams<IUpdateVisit>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useVisit(+id!);
  const { form, submit, loading } = useUpdateVisit({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("La visite a été modifiée avec succès");
    },
  });

  useEffect(() => {
    if (data?.visit?.ok && data?.visit?.result) {
      const { result } = data.visit;
      form.setValue("visitDate", result.visitDate);
      form.setValue("report", result.report);
      form.setValue("outcome", result.outcome);
      form.setValue("followUpDate", result.followUpDate);
      form.setValue("salesRepId", result.salesRep?.id);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Visite"
        subtitle={data?.visit?.result?.customer?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/visit/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier une visite" />
          <VisitForm loading={loading} form={form} submit={submit} isEditing />
        </div>
      </div>
    </>
  );
};
